export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = () => {
    // добавление этого плагина дает стабильную работу throw createError
  };
});
